import axios from "axios";

// export const LOGIN_URL = "api/auth/login";
export const baseApiUrl = process.env.REACT_APP_API_URL;
// export const baseApiUrl = "https://localhost:44360";
export const LOGIN_URL = baseApiUrl + "/api/User/Login";
// export const LOGIN_URL = "https://localhost:44360/api/User/Login";
export const ME_URL = baseApiUrl + "/api/User/Get/22";
export const REGISTER_URL = baseApiUrl + "/api/auth/register";
export const REQUEST_PASSWORD_URL = baseApiUrl + "/api/auth/forgot-password";
export const CHANGE_PASSWORD_URL = baseApiUrl + "/api/User/ChangePassword";


// export const ME_URL = "api/me";

export function login(username, password) {
  return axios.post(LOGIN_URL, null, {
    params: {
      username,
      password
    }
  })
  // return axios.post(LOGIN_URL, { username, password });
  // return axios.post(LOGIN_URL);
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  // return axios.get(ME_URL);
  return axios.get(ME_URL);
}


export function changePassword(username, oldPassword, newPassword) {
  return axios.post(CHANGE_PASSWORD_URL, null, {
    params: {
      username,
      oldPassword,
      newPassword
    }
  })
}
